module.exports = __webpack_public_path__ + "static/mid4-2adee48fb27c126aadc42dd18facbec6.png";